const PATHS = {
  ACCOUNTS_DASHBOARD: '/account/dashboard',
  ACCOUNTS_COMPANY_DETAILS: '/account/company-details',
  ACCOUNTS_YEAR_SETTING: '/account/data-reporting-year',
  ACCOUNTS_LOCATIONS: '/account/locations',
  ACCOUNTS_VEHICLES: '/account/vehicles',
  ACCOUNTS_EQUIPMENTS: '/account/equipment',
  ACCOUNTS_MY_PROFILE: '/account/myprofile',
  ACCOUNTS_CLIMATE_PROFILE: '/account/climate-profile',

  SCOPE_1_NATURAL_GAS_CONSUMPTION_LOCATION: '/scope1/naturalgasconsumption',
  SCOPE_1_VEHICLE_USAGE_FUEL: '/scope1/vehicle-usage-fuel',
  SCOPE_1_VEHICLE_USAGE_DISTANCE: '/scope1/vehicle-usage-distance',
  SCOPE_1_FUEL_CONSUMPTION_EQUIPMENT: '/scope1/fuel-consumption-equipment',
  SCOPE_1_REFRIGERANT_CONSUMPTION: '/scope1/refrigerant-consumption',
  SCOPE_1_INDUSTRIAL_GAS_CONSUMPTION: '/scope1/industrial-gas-consumption',

  SCOPE_2_ELECTRICITY_USAGE: '/scope2/electricity-usage',
  SCOPE_2_HEAT_STREAM_USAGE: '/scope2/heat-stream-usage',
  SCOPE_2_PURCHASED_COOLING: '/scope2/purchased-cooling',
  SCOPE_2_FUEL_CONSUMPTION_EQUIPMENT: '/scope2/fuel-consumption-equipment',
  SCOPE_2_REFRIGERANT_CONSUMPTION: '/scope2/refrigerant-consumption',
  SCOPE_2_INDUSTRIAL_GAS_CONSUMPTION: '/scope2/industrial-gas-consumption',

  SCOPE_3: '/scope3',

  ANALYTICS_REDUCTION_FOOTPRINT_ANALYTICS: '/analytics-reduction/footprint-analytics',
  ANALYTICS_REDUCTION_REDUCTION_TARGET_MODEL: '/analytics-reduction/reduction-target-model',

  METRIC_REPORT_GHG_METHODOLOGY: '/metric-report/ghg-methodology',
  METRIC_REPORT_IISB_GHG_METRIC: '/metric-report/iisb-ghg-metric',
  METRIC_REPORT_UNFCCC_REPORT: '/metric-report/unfccc-report',
  METRIC_REPORT_BRSR_REPORT: '/metric-report/brsr-report',

  ADD_EDIT_SOURCE_DATA_CATEGORY1:'/add-edit-source-data/category1',
  ADD_EDIT_SOURCE_DATA_CATEGORY2:'/add-edit-source-data/category2',
  ADD_EDIT_SOURCE_DATA_CATEGORY3:'/add-edit-source-data/category3',
  ADD_EDIT_SOURCE_DATA_CATEGORY4:'/add-edit-source-data/category4',
  ADD_EDIT_SOURCE_DATA_CATEGORY5:'/add-edit-source-data/category5',
  ADD_EDIT_SOURCE_DATA_CATEGORY6A:'/add-edit-source-data/category6-a',
  ADD_EDIT_SOURCE_DATA_CATEGORY6B:'/add-edit-source-data/category6-b',
  ADD_EDIT_SOURCE_DATA_CATEGORY6C:'/add-edit-source-data/category6-c',
  ADD_EDIT_SOURCE_DATA_CATEGORY6D:'/add-edit-source-data/category6-d',
  ADD_EDIT_SOURCE_DATA_CATEGORY7:'/add-edit-source-data/category7',
  ADD_EDIT_SOURCE_DATA_CATEGORY8:'/add-edit-source-data/category8',
  ADD_EDIT_SOURCE_DATA_CATEGORY9:'/add-edit-source-data/category9',
  ADD_EDIT_SOURCE_DATA_CATEGORY10:'/add-edit-source-data/category10',
  ADD_EDIT_SOURCE_DATA_CATEGORY11:'/add-edit-source-data/category11',
  ADD_EDIT_SOURCE_DATA_CATEGORY12:'/add-edit-source-data/category12',
  ADD_EDIT_SOURCE_DATA_CATEGORY13:'/add-edit-source-data/category13',
  ADD_EDIT_SOURCE_DATA_CATEGORY14:'/add-edit-source-data/category14', 
  ADD_EDIT_SOURCE_DATA_CATEGORY15:'/add-edit-source-data/category15',

  MASTERS_SCOPE3_TEMPLATE: '/masters/scope3-template',
  MASTERS_USERS:'/masters/users',
  MASTERS_EQUIPMENT_TYPES:'/masters/equipment-types',
  MASTERS_GENERAL:'/masters/general',
  MASTERS_SECTOR:'/masters/sector',
  MASTERS_INDUSTRY:'/masters/industry',
  MASTERS_SUBINDUSTRY:'/masters/subindustry',
  MASTERS_VEHICLE_TYPE:'/masters/vehicle-types',
  MASTERS_VEHICLE_SUB_TYPE:'/masters/vehicle-sub-type',
  MASTERS_VEHICLE_MAKE:'/masters/vehicle-make',
  MASTERS_VEHICLE_MODEL:'/masters/vehicle-model',
  MASTERS_COUNTRY:'/masters/country',
  MASTERS_STATES:'/masters/state',

  MASTERS_REFRIGERANT_TYPES:'/masters/refrigerant-types',
  MASTERS_FUEL_TYPES:'/masters/fuel-types',
  MASTERS_INDUSTRIAL_GAS:'/masters/industrial-gas',
  MASTERS_NATURAL_GAS:'/masters/natural-gas',

  MASTERS_PRIMARY_USAGE:'/masters/primary-usage',
  MASTERS_PRIMARY_USAGE_TYPE:'/masters/primary-usage-type',

  SCOPE3_DATA_SUBMISSION:'/admin/scope3_data_submission',
  SCOPE3_DATA_SUBMISSION_COMPANY:`/admin/scope3_data_submission/:company_id`,
  CRON_LOGS:'/admin/cron_logs',

  MASTERS_FUEL_EMISSION:'/masters/fuel-emission',
  MASTERS_INDUSTRIAL_GAS_EMISSION:'/masters/industrial-gas-emission',
  MASTERS_NATURAL_GAS_EMISSION:'/masters/natural-gas-emission',
  MASTERS_REFRIGERANT_EMISSION:'/masters/refrigerant-emission',
  MASTERS_VEHICLE_DISTANCE_WISE_EMISSION:'/masters/vehicle-distance-wise-emission',
  MASTERS_VEHICLE_FUEL_WISE_EMISSION:'/masters/vehicle-fuel-wise-emission',

  MASTERS_ELECTRICITY_EMISSION:'/masters/electricity-emission',
  MASTERS_HEAT_STEAM_EMISSION:'/masters/heatsteam-emission',
  MASTERS_PURCHASED_COOLING_EMISSION:'/masters/purchased-cooling-emission',
};


export default PATHS